webpackJsonp([35783957827783],{

/***/ 330:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot2.0a069cea.jpg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headshot = __webpack_require__(52);
	
	var _headshot2 = _interopRequireDefault(_headshot);
	
	var _gatsbyLink = __webpack_require__(150);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LowNav = function LowNav() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'nav',
	      { className: 'low-navbar' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          { className: 'zoom' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects' },
	            'Projects'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'zoom' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about' },
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'zoom' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://andrewjford.github.io/' },
	            'Blog'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'zoom' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://s3-us-west-2.amazonaws.com/resume-ford-pdf/resume.pdf' },
	            'Resume'
	          )
	        )
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'narrow-container' },
	    _react2.default.createElement(
	      'p',
	      { className: 'center-text' },
	      _react2.default.createElement('img', { className: 'headshot', src: _headshot2.default, alt: 'Headshot' })
	    ),
	    _react2.default.createElement(
	      'h1',
	      { className: 'h1-index' },
	      'Andrew Ford'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'light-text center-text' },
	      'Software Developer at Concert Health.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-bar' },
	      _react2.default.createElement(
	        'a',
	        { href: 'http://linkedin.com/in/andrew-j-ford/' },
	        _react2.default.createElement('i', { className: 'fa fa-linkedin-square' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'http://github.com/andrewjford' },
	        _react2.default.createElement('i', { className: 'fa fa-github' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:ajoeford@gmail.com' },
	        _react2.default.createElement('i', { className: 'fa fa-envelope' })
	      )
	    ),
	    _react2.default.createElement(LowNav, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-3ee6add9a7e1e6ccf3fc.js